import { MessageCircle } from 'lucide-react';
import { useSettings } from '@/context/SettingsContext';

export const WhatsAppButton = () => {
  const { settings } = useSettings();
  const whatsapp = settings?.contact?.whatsapp || '5491100000000';
  const primaryColor = settings?.theme?.primaryColor || '#1e3a5f';

  // Clean the whatsapp number (remove spaces, dashes, parentheses, etc.)
  const cleanNumber = whatsapp.replace(/[^\d]/g, '');

  return (
    <a
      href={`https://wa.me/${cleanNumber}`}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full shadow-lg hover:scale-110 transition-transform"
      style={{ backgroundColor: '#25D366' }}
      aria-label="Contactar por WhatsApp"
      data-testid="whatsapp-button"
    >
      <MessageCircle size={28} className="text-white" />
    </a>
  );
};
